export default {
  // 时间戳转换
  time(value) {
    const date = new Date(value * 1000) // 如果date为13位不需要乘1000
    const Y = date.getFullYear() + '-'
    const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
    const D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate()) + ' '
    return Y + M + D
  },
  getUrl() {
    return 'https://activityanswer.oss-cn-hangzhou.aliyuncs.com'
    // return 'http://192.168.0.115:9000'
  },
 //生成随机字符串
 randomString(len) {
  len = len || 32;
  /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
  var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
  var maxLen = $chars.length;
  var str = '';
  for (var i = 0; i < len; i++) {
    str += $chars.charAt(Math.floor(Math.random() * maxLen));
  }
  return str;
}
}